import React from 'react'

const SuccessMessage = () => (
  <div style={{ textAlign: 'center' }}>
    <h3 className="heading heading--h3" style={{ margin: 0 }}>
      Message Sent
    </h3>
    <div className="heading heading--h2 heading--accent" style={{ margin: 0 }}>
      Thank you for your enquiry
    </div>
    <p>
      A member of our team will review your submission and get back to you.
      {/* <br />
      We receive a high volume of enquiries but aim to reply within three
      business days where we think we can assist. */}
    </p>
  </div>
)

export default SuccessMessage
